export const PAGE_STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  UNAVAILABLE: "unavailable",
  EXPIRED: "expired",
  ERROR: "error",
};
